
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { ReactNode } from 'react';


interface TableProps {
    children: ReactNode
}

export default function BasicTable({ children }: TableProps) {
    return (
        <TableContainer component={Paper} style={{
            boxShadow: 'none'
        }}>
            <Table 
                sx={{ 
                    minWidth: 200, 
                    // border: '1px solid #B9B9B9' 
                }} 
                aria-label="simple table"
            >
                {children}
            </Table>
        </TableContainer>
    );
}